export let serverSideSetCol = {
	filterParams: {
		values: function (params) {
			var model = gridSettings.api.getFilterModel();
			axios.post(gridDataUrl, {
				field: params.colDef.field,
				requestType: 'getFilterValues',
				filterModel: model
			}).then(response => {
				params.success(response.data);
			});
		}
	}
}